import * as YandexMaps from './exports';
export * from './exports';
export default YandexMaps;
